import { getW } from 'Lib/w/w';
import { eksmoBP } from 'Lib/bp/bp';

if (getW() > eksmoBP.smMax) {
    const cSpoiler = 'book-page__tags_spoiler';
    const cAll = 'book-page__tags_all';
    const sItemAll = '.book-page__tags-item_all';
    const $itemAll = $(sItemAll);
    const $tags = $('.book-page__tags');
    const sItem = `.book-page__tags-item:not(${sItemAll})`;

    $tags.each(function () {
        const $this = $(this);
        const cLoaded = 'book-page__tags_loaded';
        const $item = $this.find(sItem);
        const $box = $this.find('.book-page__tags-list');
        const $content = $this.find('.book-page__tags-cont');
        const diff = Math.ceil($content.outerWidth(true) - $box.width());
        const offset = 8;
        const spoilerBtnWidth = 35 + offset;
        const resultDiff = diff + offset + spoilerBtnWidth;

        if (resultDiff > 0) {
            let sumDeleteWidth = 0;

            $($item.get().reverse()).each(function () {
                const $thisItem = $(this);

                sumDeleteWidth += Math.ceil($thisItem.outerWidth(true));
                $thisItem.hide();

                return sumDeleteWidth < resultDiff;
            });

            $this.addClass(cSpoiler);
        }

        $this.addClass(cLoaded);
    });

    $itemAll.on('click', function () {
        const $parent = $(this).closest($tags);

        $parent.removeClass(cSpoiler);
        $parent.addClass(cAll);
        $parent.find(sItem).show();
    });
}